// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthNotification_container__qp9xW"};